import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import ErrorMessage from '../error-message/ErrorMessage';
import { CustomTextarea } from './styles';
export const Textarea = forwardRef(({ onChangeText, disabled, testId, className, placeholder, value, onChange, name, errorMessage, ...rest }, ref) => {
    const handleChange = (e) => {
        if (disabled)
            return;
        if (onChange) {
            onChange(e);
        }
        else {
            const { value } = e.target;
            onChangeText?.(value);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx(CustomTextarea, { "data-cy": testId, className: className, placeholder: placeholder, value: value, onChange: handleChange, name: name, ref: ref, disabled: disabled, hasError: !!errorMessage, ...rest }), errorMessage && _jsx(ErrorMessage, { errorMessage: errorMessage })] }));
});
Textarea.displayName = 'TextArea';
export default Textarea;
//# sourceMappingURL=Textarea.js.map